<template lang="pug">
v-container(fluid fill-height id="website-theme-preview" class="pa-0 ma-0 tw-items-start tw-content-start tw-overflow-x-hidden")
  kubiqa-website-themes-theme-c-components-shared-top-navigation
  div(class="d-flex flex-row tw-relative flex-grow-1 tw-w-full tw-h-full tw-z-0")
    div(class="d-flex tw-w-full tw-p-0 tw-m-0 tw-z-0 tw-absolute tw-bg-cyan-darken-4 tw-rounded-lg tw-overflow-hidden  tw-h-full ")
      template(v-if="!page.background_image")
        v-img(:src="sampleWebsiteImage('cabin', 1080, 1080)" class="tw-opacity-75")
      template(v-else)
        v-img(:src="path(page.background_image)" class="tw-opacity-75")
    div(class="d-flex tw-w-full tw-items-center tw-relative tw-z-10 ")
      v-container(fluid pa-0 ma-0)
        v-row(no-gutters align="center" justify="center" class="  ")
          v-col(cols="12" class="tw-text-center")
            div(class="tw-grid")
              div(class="tw-z-10 tw-row-span-full tw-col-span-12 tw-col-start-1")
                kubiqa-website-shared-widget-editor(
                  page="home"
                  placement="call_out"
                  @content="(content) => (content != null ? ((defaultCallout = false), key++) : ((defaultCallout = true), key++))"
                )
              div(v-if="defaultCallout" :key="key" class="tw-z-0 tw-row-span-full tw-col-start-1 tw-col-span-12  tw-align-middle")
                div(class="tw-h-full  tw-items-center tw-flex")
                  v-row(no-gutters justify="center")
                    v-col(cols="9")
                      span(class="tw-font-bold tw-text-white tw-text-2xl") Find your next home
        v-row(dense align="center" justify="center" class=" ")
          v-col(cols="8")
            div(class="tw-bg-white tw-rounded-full tw-mx-auto tw-p-0 pl-2 tw-shadow-lg ")
              v-row(no-gutters align="center" justify="center")
                v-col(cols="auto")
                  v-combobox(solo :items="['Rent', 'Buy']" flat hide-details)
                v-col(cols="")
                  v-text-field(
                    solo
                    flat
                    hide-details
                    label="Enter Address"
                    placeholder="Enter address"
                  )
                v-col(cols="auto" class="")
                  div(class="mr-2")
                    v-btn(
                      @click=""
                      color="orange darken-4"
                      elevation="0"
                      large
                      fab
                    )
                      v-icon(large) mdi-magnify
  div(class="d-flex flex-row tw-w-full tw-rounded-lg tw-bg-gray-lighten-5 tw-mt-4")
    v-row(no-gutters align="center" justify="space-around")
      v-col(cols="12")
        div(class="tw-grid")
          div(class="tw-z-10 tw-row-span-full tw-col-span-12 tw-col-start-1")
            kubiqa-website-shared-widget-editor(
              page="home"
              placement="description"
              @content="(content) => (content != null ? ((defaultDescription = false), key++) : ((defaultDescription = true), key++))"
            )
          div(v-if="defaultDescription" :key="key" class="tw-z-0 tw-row-span-full tw-col-start-1 tw-col-span-12  tw-align-middle")
            div(class="tw-h-full  tw-items-center tw-flex")
              v-row(no-gutters justify="center")
                v-col(cols="9")
                  span(class="tw-font-bold tw-text-white tw-text-2xl") Description
  div(class="d-flex flex-row tw-w-full tw-mt-4")
    kubiqa-website-themes-theme-c-components-home-listings
  kubiqa-website-themes-theme-c-components-shared-footer
</template>
<script>
export default {
  data() {
    return {
      key: 0,
      defaultCallout: null,
      defaultDescription: null,
    };
  },
  computed: {
    page() {
      const website = this.$store.state.website.website;
      return website && website.pages ? website.pages.home || null : null;
    },
  },
};
</script>
